module.exports = __webpack_public_path__ + "img/Gehenna.b55b47ab.png";